import React from "react";

export interface QuestionPropsStruct<T extends QuestionType> {
    type: T;
    data: QuestionData[T];
    renderSubQuestion: (index: number, data: any) => React.ReactNode;
}

type QuestionContextProps =
    | QuestionPropsStruct<"SingleChoice">
    | QuestionPropsStruct<"MultiChoice">
    | QuestionPropsStruct<"Judge">
    | QuestionPropsStruct<"Fill">
    | QuestionPropsStruct<"Subjective">
    | QuestionPropsStruct<"Mixed">;

const QuestionContext = React.createContext<QuestionContextProps>({
    type: "SingleChoice",
    data: { content: "", options: [] },
    renderSubQuestion: () => null
});

export { QuestionContext };
